/**
 * The configuration for the API endpoints for the production environment and safefm_demo schema.
 */
const config = {
  endpoints: {
    /**
     * UM Configuration.
     */
    um: {
      endpoint: 'https://um.ipro.net',
      version: 1,
      status: {
        label: 'Users',
        route: 'v1/status',
      },
    },

    /**
     * VM Configuration.
     */
    vm: {
      endpoint: 'https://vm.ipro.net',
      version: 1,
      upload_path: '/vendor_documents/upload',
      status: {
        label: 'Vendors',
        route: 'v1/status',
      },
    },

    /**
     * DNA Configuration.
     */
    dna: {
      endpoint: 'https://dna.ipro.net',
    },
  },
  statusEmailUrl: 'https://xperior-services.herokuapp.com',
  authRedirectUrl: 'https://auth-demo.ipro.net',
  adminRedirectUrl: 'https://demo.ipro.net/admin/',
  portalRedirectUrl: 'https://demo.ipro.net',
  workerRedirectUrl: 'https://next-demo.ipro.net',
  mobileAppLoginUrl: 'https://access.ipro.net/Madr13iTQ0',
};

module.exports = config;
